import { FunctionComponent } from 'react';
import { Close } from '../../components/icons';
import { Button, IconButton } from '../../tailwindcomponents';
import { Typography } from './../../tailwindcomponents';
import IcelandairLogo from '../../assets/icelandairLogo.svg';
import { securityResult } from '../../types/security';

type ReportInfoProps = {
    selectedReport: securityResult,
    closeReport: Function,
    submitReport: Function,
    isSecurityAdmin: Boolean
}

const ReportInfo: FunctionComponent<ReportInfoProps> = ({ selectedReport, closeReport, submitReport, isSecurityAdmin }) => {

    // Header of the report. Submit button is only displayed when in edit mode
    return (
        <div className="mb-4">
            <div className="flex flex-wrap w-full">
                <div className="w-7/12">
                    <Typography variant='h1' text={"Security Report"} align='left' />
                </div>
                <div className="w-1/3">
                    <img src={IcelandairLogo} className="h-[50px] bottom-[5px] relative" alt="Logo" />
                </div>
                <div className="w-1/12">
                    <IconButton onClick={() => closeReport()} color="default" >
                        <Close />
                    </IconButton>
                </div>
            </div>
            <hr />
            <div className="flex flex-wrap w-5/6 mt-2" >
                {isSecurityAdmin && !selectedReport.report.closed &&
                    <div className="w-full">
                        <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            onClick={() => submitReport()}>
                            Submit Report
                        </Button>
                    </div>
                }
                <div className="lg:w-1/6 w-1/2"><Typography paragraph={true} fontWeight='bold' text='Report created by:' /></div>
                <div className="lg:w-5/6 w-1/2">{selectedReport.report.general_info.created_by_employee_name} at {selectedReport.report.general_info.created_date_text} </div>
                <div className="lg:w-1/6 w-1/2"><Typography paragraph={true} fontWeight='bold' text='Last modified by:' /></div>
                <div className="lg:w-5/6 w-1/2">{selectedReport.report.general_info.last_modified_date_by_employee_name !== "" && selectedReport.report.general_info.last_modified_date_by_employee_name + ' at ' + selectedReport.report.general_info.last_modified_date_text}</div>
            </div>
        </div>
    );
};
export default ReportInfo;
